import { ActionController, ActionControllerEventName } from "@g.frame/common.action_controller";
import { TextComponent } from "@g.frame/components.text";
import { WindowComponent } from "@g.frame/components.window";
import { ParentEvent, ViewerModule } from "@g.frame/core";
import { Group, Vector2 } from "three";
export default class SelectComponent extends ViewerModule {
    constructor(modulesProcessor) {
        super();
        this.modulesProcessor = modulesProcessor;
        this.mainContainer = new Group;
        this.actionController = this.modulesProcessor.agents.get(ActionController);
        this.addObject(this.mainContainer);
    }
    init(config) {
        var _a;
        if (((_a = this.buttonsList) === null || _a === void 0 ? void 0 : _a.length) > 0)
            this.buttonsList.forEach(el => {
                this.disposeObject(el);
            });
        this.buttonsList = [];
        const size = config.buttonSize;
        const totalWidth = config.options.length * size.x + (config.options.length - 1) * config.margin;
        const startOffset = -totalWidth / 2 + size.x / 2;
        config.options.forEach((option, index) => {
            const button = this.createButtonSet(option, size);
            button.position.x = startOffset + (size.x + config.margin) * index;
            this.mainContainer.add(button);
            this.buttonsList.push(button);
        });
        this.buttonsList.forEach((button) => {
            this.actionController.on(ActionControllerEventName.click, button, () => {
                this.buttonsList.forEach((button) => {
                    button.userData.select(false);
                });
                button.userData.select(true);
                this.fire('button_pressed', new ParentEvent('button_pressed', { data: button.userData }));
            });
        });
    }
    createButtonSet(option, size) {
        const setGroup = new Group;
        const baseButtonOptions = {
            border: 0xC2C0BC,
            background: '#E5E6E0',
            text: '#63615E',
        };
        const baseButton = this.createButton(option.text, size, baseButtonOptions);
        const selectButtonOptions = {
            border: 0x5D772E,
            background: '#9DC458',
            text: '#FFFFFF',
        };
        const selectButton = this.createButton(option.text, size, selectButtonOptions);
        selectButton.visible = false;
        const errorButtonOptions = {
            border: 0xDB5B4A,
            background: '#FDD1D1',
            text: '#63615E',
        };
        const errorButton = this.createButton(option.text, size, errorButtonOptions);
        errorButton.visible = false;
        setGroup.add(baseButton);
        setGroup.add(selectButton);
        setGroup.add(errorButton);
        setGroup.userData = {
            text: option.text,
            selected: false,
            correct: option.correct,
            select: (selected) => {
                baseButton.visible = !selected;
                selectButton.visible = selected && option.correct;
                errorButton.visible = selected && !option.correct;
                setGroup.userData.selected = selected;
            }
        };
        return setGroup;
    }
    createButton(text, size, buttonStyle) {
        const buttonGroup = new Group;
        const border = new WindowComponent({
            size: size.clone(),
            bordRadius: size.y / 5,
            background: buttonStyle.border
        });
        border.uiObject.position.z = -0.0001;
        border.uiObject.visible = true;
        const button = new TextComponent({
            size: size.clone().addScalar(-size.y / 10),
            pxSize: new Vector2(64 * size.x / size.y, 64),
            text: {
                value: text,
                autoWrappingHorizontal: false,
                autoWrapping: false,
                align: 'center',
                style: {
                    family: 'ProximaNova',
                    weight: '600',
                    size: '26px',
                    color: buttonStyle.text
                },
                margin: 0.001,
                lineHeight: 42,
            },
            background: {
                radius: size.y / 6,
                color: buttonStyle.background
            }
        });
        buttonGroup.add(button.uiObject);
        buttonGroup.add(border.uiObject);
        return buttonGroup;
    }
    getSelection() {
        const button = this.buttonsList.find((item) => item.userData.selected);
        return button;
    }
}
